import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import {
  AwardsWrapper,
  WineDescription,
  Quotes,
} from 'components/Pages/Wine/View/Main/Content/ColumnRight/_styles'
import { EmptyInfo } from 'components/Pages/Wine/View/Main/Content/ColumnLeft/_styles'
import AwardsList from 'components/Pages/Wine/View/Main/Content/ColumnRight/Awards/AwardsList'
import Collapsable from 'components/Pages/Wine/View/Common/Collapsable'
import breakpoints from 'utils/consts/breakpoints'
import backgroundUrl from 'components/Pages/Wine/View/Main/Content/ColumnRight/Awards/_assets/background.svg'
import { useProduct } from 'components/Pages/Wine/View/Main/_methods'

const Wrapper = styled.div`
  @media screen and ${breakpoints.device.desktop},
    ${breakpoints.device.laptop},
    ${breakpoints.device.tablet} {
    background-image: url(${backgroundUrl});
    background-repeat: no-repeat;
    background-position: center;
  }
`

const Awards = () => {
  const { t } = useTranslation()
  const product = useProduct()
  const wine = product?.wine as any

  const description = wine?.techSheets?.[0]?.marketingNote ?? ''

  // ClusterWineAward: { minScore, maxScore, year, award, rewards }
  const awards = [...(wine?.awards ?? [])].sort(
    (a, b) => (a.year ?? Infinity) - (b.year ?? Infinity)
  )

  // Адаптируем ClusterWineAward → shape ожидаемый AwardsList
  const notSpecified = t('common.notSpecified')
  const adaptedAwards = awards.map(a => ({
    id: a.award?.id ?? Math.random(),
    year: a.year ?? notSpecified,
    award: a.award,
    minScore: a.minScore,
    maxScore: a.maxScore,
    rewards: a.rewards,
  }))

  return (
    <Wrapper>
      <Collapsable title={t('wine.view.awards')}>
        <AwardsWrapper>
          {adaptedAwards.length > 0 && (
            <AwardsList awards={adaptedAwards as any} />
          )}
          {adaptedAwards.length === 0 && !description && (
            <EmptyInfo>{t('capturedWine.view.noAwards')}</EmptyInfo>
          )}
          {adaptedAwards.length <= 2 && description && (
            <WineDescription
              {...{ align: adaptedAwards.length > 0 ? 'left' : 'center' }}
            >
              <Quotes>&ldquo;</Quotes>
              {description?.trim()}
              <Quotes>&rdquo;</Quotes>
            </WineDescription>
          )}
        </AwardsWrapper>
      </Collapsable>
    </Wrapper>
  )
}

export default Awards
